// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UtvarderingRouteImport } from './routes/utvardering'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TrelloInsikterRouteImport } from './routes/trello-insikter'
import { Route as TrelloRouteImport } from './routes/trello'
import { Route as StrategirapportRouteImport } from './routes/strategirapport'
import { Route as SentryTestRouteImport } from './routes/sentry-test'
import { Route as SammanstallningRouteImport } from './routes/sammanstallning'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RapporterRouteImport } from './routes/rapporter'
import { Route as PortfoljRouteImport } from './routes/portfolj'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as OversiktRouteImport } from './routes/oversikt'
import { Route as ManadsrapportRouteImport } from './routes/manadsrapport'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ImpactRouteImport } from './routes/impact'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FinansieringRouteImport } from './routes/finansiering'
import { Route as CoachPortalRouteImport } from './routes/coach-portal'
import { Route as CoachMatchningRouteImport } from './routes/coach-matchning'
import { Route as CoachLoginRouteImport } from './routes/coach-login'
import { Route as CoachBolagRouteImport } from './routes/coach-bolag'
import { Route as BolagPortalRouteImport } from './routes/bolag-portal'
import { Route as BolagLoginRouteImport } from './routes/bolag-login'
import { Route as AntagningskriterierRouteImport } from './routes/antagningskriterier'
import { Route as AdressregisterRouteImport } from './routes/adressregister'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CoacherIndexRouteImport } from './routes/coacher.index'
import { Route as RapportTokenRouteImport } from './routes/rapport.$token'
import { Route as CoacherIdRouteImport } from './routes/coacher.$id'
import { Route as CoachFormularTokenRouteImport } from './routes/coach-formular.$token'
import { Route as CoachAccessTokenRouteImport } from './routes/coach-access.$token'
import { Route as BolagIdRouteImport } from './routes/bolag.$id'
import { Route as UtvarderingIdRouteImport } from './routes/utvardering.$id'
import { Route as ManadsrapportCompanyIdRouteImport } from './routes/manadsrapport.$companyId'
import { Route as CoachPortalIndexRouteImport } from './routes/coach-portal.index'
import { Route as CoachPortalCompanyIdRouteImport } from './routes/coach-portal.$companyId'
import { Route as CoachPortalCompanyIdRapportRouteImport } from './routes/coach-portal.$companyId.rapport'

const UtvarderingRoute = UtvarderingRouteImport.update({
            id: '/utvardering',path: '/utvardering',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TrelloInsikterRoute = TrelloInsikterRouteImport.update({
            id: '/trello-insikter',path: '/trello-insikter',getParentRoute: () => rootRouteImport
          })
const TrelloRoute = TrelloRouteImport.update({
            id: '/trello',path: '/trello',getParentRoute: () => rootRouteImport
          })
const StrategirapportRoute = StrategirapportRouteImport.update({
            id: '/strategirapport',path: '/strategirapport',getParentRoute: () => rootRouteImport
          })
const SentryTestRoute = SentryTestRouteImport.update({
            id: '/sentry-test',path: '/sentry-test',getParentRoute: () => rootRouteImport
          })
const SammanstallningRoute = SammanstallningRouteImport.update({
            id: '/sammanstallning',path: '/sammanstallning',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RapporterRoute = RapporterRouteImport.update({
            id: '/rapporter',path: '/rapporter',getParentRoute: () => rootRouteImport
          })
const PortfoljRoute = PortfoljRouteImport.update({
            id: '/portfolj',path: '/portfolj',getParentRoute: () => rootRouteImport
          })
const PipelineRoute = PipelineRouteImport.update({
            id: '/pipeline',path: '/pipeline',getParentRoute: () => rootRouteImport
          })
const OversiktRoute = OversiktRouteImport.update({
            id: '/oversikt',path: '/oversikt',getParentRoute: () => rootRouteImport
          })
const ManadsrapportRoute = ManadsrapportRouteImport.update({
            id: '/manadsrapport',path: '/manadsrapport',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ImpactRoute = ImpactRouteImport.update({
            id: '/impact',path: '/impact',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FinansieringRoute = FinansieringRouteImport.update({
            id: '/finansiering',path: '/finansiering',getParentRoute: () => rootRouteImport
          })
const CoachPortalRoute = CoachPortalRouteImport.update({
            id: '/coach-portal',path: '/coach-portal',getParentRoute: () => rootRouteImport
          })
const CoachMatchningRoute = CoachMatchningRouteImport.update({
            id: '/coach-matchning',path: '/coach-matchning',getParentRoute: () => rootRouteImport
          })
const CoachLoginRoute = CoachLoginRouteImport.update({
            id: '/coach-login',path: '/coach-login',getParentRoute: () => rootRouteImport
          })
const CoachBolagRoute = CoachBolagRouteImport.update({
            id: '/coach-bolag',path: '/coach-bolag',getParentRoute: () => rootRouteImport
          })
const BolagPortalRoute = BolagPortalRouteImport.update({
            id: '/bolag-portal',path: '/bolag-portal',getParentRoute: () => rootRouteImport
          })
const BolagLoginRoute = BolagLoginRouteImport.update({
            id: '/bolag-login',path: '/bolag-login',getParentRoute: () => rootRouteImport
          })
const AntagningskriterierRoute = AntagningskriterierRouteImport.update({
            id: '/antagningskriterier',path: '/antagningskriterier',getParentRoute: () => rootRouteImport
          })
const AdressregisterRoute = AdressregisterRouteImport.update({
            id: '/adressregister',path: '/adressregister',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CoacherIndexRoute = CoacherIndexRouteImport.update({
            id: '/coacher/',path: '/coacher/',getParentRoute: () => rootRouteImport
          })
const RapportTokenRoute = RapportTokenRouteImport.update({
            id: '/rapport/$token',path: '/rapport/$token',getParentRoute: () => rootRouteImport
          })
const CoacherIdRoute = CoacherIdRouteImport.update({
            id: '/coacher/$id',path: '/coacher/$id',getParentRoute: () => rootRouteImport
          })
const CoachFormularTokenRoute = CoachFormularTokenRouteImport.update({
            id: '/coach-formular/$token',path: '/coach-formular/$token',getParentRoute: () => rootRouteImport
          })
const CoachAccessTokenRoute = CoachAccessTokenRouteImport.update({
            id: '/coach-access/$token',path: '/coach-access/$token',getParentRoute: () => rootRouteImport
          })
const BolagIdRoute = BolagIdRouteImport.update({
            id: '/bolag/$id',path: '/bolag/$id',getParentRoute: () => rootRouteImport
          })
const UtvarderingIdRoute = UtvarderingIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => UtvarderingRoute
          })
const ManadsrapportCompanyIdRoute = ManadsrapportCompanyIdRouteImport.update({
            id: '/$companyId',path: '/$companyId',getParentRoute: () => ManadsrapportRoute
          })
const CoachPortalIndexRoute = CoachPortalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CoachPortalRoute
          })
const CoachPortalCompanyIdRoute = CoachPortalCompanyIdRouteImport.update({
            id: '/$companyId',path: '/$companyId',getParentRoute: () => CoachPortalRoute
          })
const CoachPortalCompanyIdRapportRoute = CoachPortalCompanyIdRapportRouteImport.update({
            id: '/rapport',path: '/rapport',getParentRoute: () => CoachPortalCompanyIdRoute
          })





const CoachPortalCompanyIdRouteChildren = {
  CoachPortalCompanyIdRapportRoute: CoachPortalCompanyIdRapportRoute
}

const CoachPortalCompanyIdRouteWithChildren = CoachPortalCompanyIdRoute._addFileChildren(CoachPortalCompanyIdRouteChildren)



const CoachPortalRouteChildren = {
  CoachPortalCompanyIdRoute: CoachPortalCompanyIdRouteWithChildren,CoachPortalIndexRoute: CoachPortalIndexRoute
}

const CoachPortalRouteWithChildren = CoachPortalRoute._addFileChildren(CoachPortalRouteChildren)




const ManadsrapportRouteChildren = {
  ManadsrapportCompanyIdRoute: ManadsrapportCompanyIdRoute
}

const ManadsrapportRouteWithChildren = ManadsrapportRoute._addFileChildren(ManadsrapportRouteChildren)




const UtvarderingRouteChildren = {
  UtvarderingIdRoute: UtvarderingIdRoute
}

const UtvarderingRouteWithChildren = UtvarderingRoute._addFileChildren(UtvarderingRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,AdressregisterRoute: AdressregisterRoute,AntagningskriterierRoute: AntagningskriterierRoute,BolagLoginRoute: BolagLoginRoute,BolagPortalRoute: BolagPortalRoute,CoachBolagRoute: CoachBolagRoute,CoachLoginRoute: CoachLoginRoute,CoachMatchningRoute: CoachMatchningRoute,CoachPortalRoute: CoachPortalRouteWithChildren,FinansieringRoute: FinansieringRoute,ForgotPasswordRoute: ForgotPasswordRoute,ImpactRoute: ImpactRoute,LoginRoute: LoginRoute,ManadsrapportRoute: ManadsrapportRouteWithChildren,OversiktRoute: OversiktRoute,PipelineRoute: PipelineRoute,PortfoljRoute: PortfoljRoute,RapporterRoute: RapporterRoute,ResetPasswordRoute: ResetPasswordRoute,SammanstallningRoute: SammanstallningRoute,SentryTestRoute: SentryTestRoute,StrategirapportRoute: StrategirapportRoute,TrelloRoute: TrelloRoute,TrelloInsikterRoute: TrelloInsikterRoute,UnsubscribeRoute: UnsubscribeRoute,UtvarderingRoute: UtvarderingRouteWithChildren,BolagIdRoute: BolagIdRoute,CoachAccessTokenRoute: CoachAccessTokenRoute,CoachFormularTokenRoute: CoachFormularTokenRoute,CoacherIdRoute: CoacherIdRoute,RapportTokenRoute: RapportTokenRoute,CoacherIndexRoute: CoacherIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)